import { Form } from "antd";

export const useForm = Form.useForm;

export const useFormWatch = Form.useWatch;

export const useFormInstance = Form.useFormInstance;
